<template>
  <template-tabs></template-tabs>
</template>

<script lang="ts">
import templateTabs from '@/app-template/lib/pages/Tabs.vue';
export default {
  name: "Tabs",
  components: { templateTabs },
};
</script>